<template>
  <div>
    <MasterLayout>
      <div class="fuel_consumption_row" ref="tableREF">
        <div class="card_container" style="flex: 0 0 23%; border-radius: 10px">
          <div class="row align-items-center fuel_consumption_buttons_row">
            <div class="col-md-6 mt-3 fuel_consumption_btn_div">
              <div
                class="fuel_consumption_button"
                @click="activateTab('table')"
                :class="[activeTab === 'table' ? 'active_tab' : null]"
              >
                <img src="@/assets/img/list.png" width="60%" />
              </div>
              <div class="text-center voucher_type">
                {{ $t("text.sales.table") }}
              </div>
            </div>
            <div class="col-md-6 fuel_consumption_btn_div mt-3">
              <div
                class="fuel_consumption_button"
                @click="activateTab('chart')"
                :class="[activeTab === 'chart' ? 'active_tab' : null]"
              >
                <img src="@/assets/img/analytics.png" width="60%" />
              </div>
              <div class="text-center voucher_type">
                {{ $t("text.sales.chart") }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuel_consumption_row_right_section mr-3 pump__bg"
          style="border-radius: 12px; flex: 0 0 72%"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(41, 39, 39 , 0.92), rgb(41, 39, 39, 0.92)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div
            class="row align-items-center justify-content-center"
            style="height: 100%"
          >
            <div
              class="col-md-5"
              style="display: flex; justify-content: space-between"
            >
              <h4 class="text-center text-white">
                {{ $t("text.sales.stationName") }}
              </h4>
            </div>
            <div
              class="col-md-4"
              style="display: flex; justify-content: center"
            >
              <vue-ctk-date-time-picker
                v-model="dateRange"
                :max-date="maxDate"
                :range="true"
                :autoClose="true"
                :locale="this.$root.$i18n.locale"
                :custom-shortcuts="customShortcuts"
                :color="$store.getters.getDatePickerColor"
                format="DDMMYYYY"
                formatted="DD/MM/YYYY"
                :label="$t('text.calendar.dateRange')"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- CUMMULATIVE CARDS -->
      <div class="section__row mt-3">
        <section class="mt-3 row dashboard_first_row">
          <section class="col-md-3 card_row" v-if="hasPms">
            <div class="mt-3 card_container_1 dashboard_card_1">
              <div class="clearfix">
                <div class="left_div">
                  <h4 class="stations_card_header">
                    {{ countryProducts.products.product1 }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4 class="stations_card_header">
                    {{ convertThousand(pmsSummary.volume) }}
                  </h4>
                </div>
              </div>
              <div class="mt-2 row dashboard_card">
                <div class="col-lg-3 col-md-3 col-sm-12">
                  <div class="oil_drop_div_1">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                </div>
                <div class="text-right col-lg-9 col-md-9 col-sm-4"></div>
              </div>
              <div class="mt-3 row dashboard_card">
                <div class="col-lg-4 col-md-4 col-sm-12 percent__column"></div>
                <div class="text-right col-lg-8 col-md-8 col-sm-4">
                  <h4 class="dashboard__footer__amount" style="font-size: 23px">
                    {{ company ? company.currencyCode : ""
                    }}{{ convertThousand(pmsSummary.amount) }}
                    <!-- {{ $n(pmsSummary.amount, "currency") }} -->
                  </h4>
                </div>
              </div>
            </div>
          </section>
          <section class="col-md-3 card_row" v-if="hasAgo">
            <div class="mt-3 card_container_1 dashboard_card_1">
              <div class="clearfix">
                <div class="left_div">
                  <h4 class="stations_card_header_1">
                    {{ countryProducts.products.product2 }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4 class="stations_card_header_1">
                    {{ convertThousand(agoSummary.volume) }}
                  </h4>
                </div>
              </div>
              <div class="mt-2 row dashboard_card">
                <div class="col-lg-3 col-md-3 col-sm-12">
                  <div class="oil_drop_div_2">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                </div>
                <div class="text-right col-lg-9 col-md-9 col-sm-4"></div>
              </div>
              <div class="mt-3 row dashboard_card">
                <div class="col-lg-4 col-md-4 col-sm-12 percent__column"></div>
                <div class="text-right col-lg-8 col-md-8 col-sm-4">
                  <h4
                    class="dashboard__footer__amount_1"
                    style="font-size: 23px"
                  >
                    {{ company ? company.currencyCode : ""
                    }}{{ convertThousand(agoSummary.amount) }}
                    <!-- {{ $n(agoSummary.amount, "currency") }} -->
                  </h4>
                </div>
              </div>
            </div>
          </section>
          <section class="col-md-3 card_row" v-if="hasDpk">
            <div class="mt-3 card_container_1 dashboard_card_1">
              <div class="clearfix">
                <div class="left_div">
                  <h4 class="stations_card_header_2">
                    {{ countryProducts.products.product3 }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4 class="stations_card_amount_header_3">
                    {{ convertThousand(dpkSummary.volume) }}
                  </h4>
                </div>
              </div>
              <div class="mt-2 row dashboard_card">
                <div class="col-lg-3 col-md-3 col-sm-12">
                  <div class="oil_drop_div_3">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                </div>
                <div class="text-right col-lg-8 col-md-8 col-sm-4"></div>
              </div>
              <div class="mt-3 row dashboard_card">
                <div class="col-lg-4 col-md-4 col-sm-12 percent__column"></div>
                <div class="text-right col-lg-8 col-md-9 col-sm-8">
                  <h4
                    class="dashboard__footer__amount_2"
                    style="font-size: 23px"
                  >
                    {{ company ? company.currencyCode : ""
                    }}{{ dpkSummary.amount }}

                    <!-- {{ $n(dpkSummary.amount, "currency") }} -->
                  </h4>
                </div>
              </div>
            </div>
          </section>
          <section class="col-md-3 card_row" v-if="hasLpg">
            <div class="mt-3 card_container_1 dashboard_card_1">
              <div class="clearfix">
                <div class="left_div">
                  <h4 class="stations_card_header_1" style="color: purple">
                    {{ countryProducts.products.product4 }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4 class="stations_card_header_1" style="color: purple">
                    {{ convertThousand(lpgSummary.volume) }}
                  </h4>
                </div>
              </div>
              <div class="mt-2 row dashboard_card">
                <div class="col-lg-3 col-md-3 col-sm-12">
                  <div class="oil_drop_div_2" style="background: purple">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                </div>
                <div class="text-right col-lg-9 col-md-9 col-sm-4"></div>
              </div>
              <div class="mt-3 row dashboard_card">
                <div class="col-lg-4 col-md-4 col-sm-12 percent__column"></div>
                <div class="text-right col-lg-8 col-md-8 col-sm-4">
                  <h4
                    class="dashboard__footer__amount_1"
                    style="font-size: 23px; color: purple"
                  >
                    {{ company ? company.currencyCode : ""
                    }}{{ convertThousand(lpgSummary.amount) }}
                    <!-- {{ $n(lpgSummary.amount, "currency") }} -->
                  </h4>
                </div>
              </div>
            </div>
          </section>
          <section class="col-md-3 card_row">
            <div class="mt-3 card_container_1 dashboard_card_1">
              <div class="clearfix">
                <div class="left_div">
                  <h4 class="stations_card_header_3">
                    {{ $t("text.salesTransactions.total") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4 class="stations_card_amount_header_4">
                    {{
                      convertThousand(
                        pmsSummary.volume +
                          agoSummary.volume +
                          dpkSummary.volume +
                          lpgSummary.volume
                      )
                    }}
                  </h4>
                </div>
              </div>
              <div class="mt-2 row dashboard_card">
                <div class="col-lg-3 col-md-3 col-sm-12">
                  <div class="oil_drop_div_4">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                </div>
                <div class="text-right col-lg-8 col-md-8 col-sm-4"></div>
              </div>
              <div class="mt-3 row dashboard_card">
                <div class="col-lg-4 col-md-4 col-sm-12 percent__column"></div>
                <div class="text-right col-lg-8 col-md-8 col-sm-4">
                  <h4
                    class="dashboard__footer__amount_3"
                    style="font-size: 23px"
                  >
                    {{ company ? company.currencyCode : ""
                    }}{{
                      convertThousand(
                        pmsSummary.amount +
                          agoSummary.amount +
                          dpkSummary.amount +
                          lpgSummary.amount
                      )
                    }}
                    <!-- {{
                      $n(
                        pmsSummary.amount +
                          agoSummary.amount +
                          dpkSummary.amount +
                          lpgSummary.amount,
                        "currency"
                      )
                    }} -->
                  </h4>
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>

      <section class="section__row mt-3">
        <div class="">
          <div class="row top_section_row">
            <div class="col-md-8 sec_text_color">
              <span>
                {{ $t("text.sales.salesReport") }}
                {{ $d(new Date(startDate), "short", this.$root.$i18n.locale) }}
                {{ $t("text.and.text") }}
                {{ $d(new Date(endDate), "short", this.$root.$i18n.locale) }}
              </span>
              <span> </span>
            </div>

            <div class="col-md-4 text-right">
              <!-- <button
                class="btn primary-border dealers_btn primary-color"
                @click="DownloadReport"
              >
                <i
                  class="fa fa-download mr-2 primary-color"
                  aria-hidden="true"
                ></i>
                Download Report
              </button> -->
            </div>
          </div>
          <div v-show="activeTab === 'table'">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <!-- field="pin" -->
              <e-columns>
                <e-column width="40" field="index" headerText="#"></e-column>
                <e-column
                  field="branchName"
                  width="200"
                  :headerText="$t('text.sales.stationName')"
                ></e-column>
                <e-column
                  width="130"
                  field="state"
                  :headerText="$t('text.sales.state')"
                ></e-column>
                <e-column
                  field="region"
                  width="280"
                  :headerText="$t('text.sales.region')"
                ></e-column>
                <e-column
                  :visible="hasPms ? true : false"
                  field="pmsVolume"
                  width="200"
                  format="N2"
                  :headerText="`${countryProducts.products.product1} ${$t(
                    'text.sales.vol'
                  )}`"
                ></e-column>
                <e-column
                  :visible="hasPms ? true : false"
                  field="pmsAmount"
                  width="200"
                  format="N2"
                  :headerText="`${countryProducts.products.product1} ${$t(
                    'text.sales.amount',
                    { currency: `(${company ? company.currency : ''})` }
                  )}`"
                ></e-column>
                <e-column
                  :visible="hasAgo ? true : false"
                  field="agoVolume"
                  width="200"
                  format="N2"
                  :headerText="`${countryProducts.products.product2} ${$t(
                    'text.sales.vol'
                  )}`"
                ></e-column>
                <e-column
                  :visible="hasAgo ? true : false"
                  field="agoAmount"
                  width="200"
                  format="N2"
                  :headerText="`${countryProducts.products.product2} ${$t(
                    'text.sales.amount',
                    { currency: `(${company ? company.currency : ''})` }
                  )}`"
                ></e-column>
                <e-column
                  :visible="hasDpk ? true : false"
                  field="dpkVolume"
                  width="200"
                  format="N2"
                  :headerText="`${countryProducts.products.product3} ${$t(
                    'text.sales.vol'
                  )}`"
                ></e-column>
                <e-column
                  :visible="hasDpk ? true : false"
                  field="dpkAmount"
                  width="200"
                  format="N2"
                  :headerText="`${countryProducts.products.product3} ${$t(
                    'text.sales.amount',
                    { currency: `(${company ? company.currency : ''})` }
                  )}`"
                ></e-column>
                <e-column
                  :visible="hasLpg ? true : false"
                  field="lpgVolume"
                  width="200"
                  format="N2"
                  :headerText="`${countryProducts.products.product4} ${$t(
                    'text.sales.vol'
                  )}`"
                ></e-column>
                <e-column
                  :visible="hasLpg ? true : false"
                  field="lpgAmount"
                  width="200"
                  format="N2"
                  :headerText="`${countryProducts.products.product4} ${$t(
                    'text.sales.amount',
                    { currency: `(${company ? company.currency : ''})` }
                  )}`"
                ></e-column>
                <e-column
                  field="totalAmount"
                  width="150"
                  format="N2"
                  :headerText="
                    $t('text.sales.total', {
                      currency: `(${company ? company.currency : ''})`,
                    })
                  "
                ></e-column>
              </e-columns>
            </ejs-grid>
          </div>
          <TableLoader :showLoader="showLoader" />
          <section v-show="activeTab === 'chart'" class="section_2">
            <highcharts
              :options="chartOptions"
              class="high_charts high__charts__fuel__consumption mr-3"
              v-if="!showLoader"
            ></highcharts>
            <div
              class="showLoaderDiv charts__loader"
              style=""
              v-if="showLoader"
            >
              <div :class="showLoader ? 'loading' : null"></div>
            </div>
          </section>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/MobileWallet.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import { Chart } from "highcharts-vue";
import TableLoader from "@/components/tableLoader/index";
import countryProducts from "@/products";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Sales :: Epump Portal",
  name: "companyTotalSales",
  components: {
    MasterLayout,
    highcharts: Chart,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      // countryProducts: localStorage.getItem('countryProducts') ? JSON.parse(localStorage.countryProducts) : countryProducts,
      backgroundUrl,
      pmsVol: 0,
      pmsSales: 0,
      companySalesTransactions: [],
      agoVol: 0,
      agoSales: 0,
      dpkVol: 0,
      dpkSales: 0,
      totalCompanySales: 0,
      hasLpg: false,
      hasPms: false,
      hasAgo: false,
      hasDpk: false,
      pmsSummary: { volume: 0, amount: 0 },
      agoSummary: { volume: 0, amount: 0 },
      dpkSummary: { volume: 0, amount: 0 },
      lpgSummary: { volume: 0, amount: 0 },
      cardBackgroundUrl,
      chartOptions: {
        colors: [
          "rgb(15, 206, 41)",
          "rgb(0, 172, 237)",
          "rgb(216, 153, 28)",
          "purple",
        ],
        chart: {
          type: "areaspline",
        },
        title: {
          text: this.$t("text.sales.totalVolumeSold"),
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.5,
          },
        },
        series: [],
        yAxis: {
          title: {
            text: this.$t("text.sales.totalVolumeSold"),
          },
        },
        xAxis: {
          categories: [],
        },
        legend: {
          enabled: true,
          layout: "horizontal",
          align: "center",
          position: "bottom",
          verticalAlign: "bottom",
          horizontalAlign: "bottom",
        },
      },
      companyChartOptions: {
        colors: ["rgb(15, 206, 41)", "rgb(0, 172, 237)", "rgb(216, 153, 28)"],
        chart: {
          type: "column",
        },
        title: {
          text: this.$t("text.sales.totalVolumeForDealers"),
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.5,
          },
        },
        series: [],
        yAxis: {
          title: {
            text: "Total Volumes of Products sold by Dealers",
          },
        },
        xAxis: {
          categories: [],
        },
        legend: {
          enabled: true,
          layout: "horizontal",
          align: "center",
          verticalAlign: "bottom",
        },
      },
      showLoader: false,
      activeTab: "table",
      showEmptyTableMessage: false,
      generatedVouchers: 0,
      salesTransactions: [],
      company: null,
      vouchersArray: [],
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 50,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),

      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      cTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            //<button style="background: none !important; border: none !important"><span>{{Xword(data.pin)}} </span>&nbsp; <a class="show-pin pull-right" :data-pin="{{data.pin}}" @click="click(event)"><i class="fa fa-eye"></i></a></button>
            template:
              '<div><span>{{crossWord(data.pin)}} </span>&nbsp; <a class="show-pin pull-right" :data-pin="data.pin" v-on:click="click($event)"><i class="fa fa-eye"></i></a></div>',
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              click: function (e) {
                this.$eventHub.$emit("detail", e);
              },
              crossWord: function (word) {
                let pre = word.substr(0, 2);
                let suff = word.substr(word.length - 1, 1);
                let xes = "";
                for (let i = 0; i < word.length - 3; i++) {
                  xes += "X";
                }
                return pre + xes + suff;
              },
            },
          }),
        };
      },
    };
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (this.$route.query.companyId) {
      this.getCompanyBranchSalesTransactons();
    }
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
    this.$eventHub.$on("detail", (e) => {
      this.togglePin(e);
    });

    this.$eventHub.$on("voucherCheck", (event, voucher) => {
      this.createSendSmsMailArray(event, voucher);
    });

    this.$eventHub.$on("selectAll", (event) => {
      this.selectAll(event);
    });
  },
  computed: {
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
  },
  beforeDestroy() {
    this.$eventHub.$off("detail");
    this.$eventHub.$off("voucherCheck");
    this.$eventHub.$off("selectAll");
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getCompanyBranchSalesTransactons();
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.getCompanyBranchSalesTransactons();
      }
    },
  },
  mounted() {
    let _this = this;

    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    decimalThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    DownloadReport() {
      this.axios({
        url: `${
          configObject.pdfBaseUrl
        }/EpumpReport/Company/CompanyBranchSalesReport?startDate=${
          this.startDate
        }&endDate=${this.endDate}&companyId=${
          this.$route.query.companyId
            ? this.$route.query.companyId
            : this.company.id
        }`,
        method: "GET",
        headers: configObject.authConfig().headers,
        responseType: "blob",
      })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "Company-branch-sales.pdf");
          document.body.appendChild(fileLink);

          fileLink.click();

          this.$toast("Download Successful", {
            type: "success",
            timeout: 3000,
          });
          this.isButtonDisabled = false;
          if (!value) {
            $(".loader").hide();
          } else {
            $(".loader1").hide();
          }
        })
        .catch((e) => {
          if (!value) {
            this.isButtonDisabled_1 = false;
            $(".loader").show();
          } else {
            this.isButtonDisabled_2 = false;
            $(".loader1").show();
          }
        });
    },
    getCompanyBranchSalesTransactons() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/CompanyBranchSales/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }/${this.startDate}/${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.displayProductSummary(response.data);
          response.data.sort((a, b) => {
            var x = a.branchName.toLowerCase();
            var y = b.branchName.toLowerCase();
            if (x < y) {
              return -1;
            }
            if (x > y) {
              return 1;
            }
            return 0;
          });
          this.parseBranch(response.data);
          this.showLoader = false;
        })
        .catch((error) => {});
    },
    displayProductSummary(productSummary) {
      let prodCount = 0;
      let psummary = productSummary.filter(
        (prod) =>
          prod.product.toLowerCase() ==
          this.countryProducts.productsLower.product1
      );
      if (psummary.length) {
        let volume = psummary.reduce((prev, cur) => {
          return Number(prev) + Number(cur.volumeSold);
        }, 0);

        let amount = psummary.reduce((prev, cur) => {
          return Number(prev) + Number(cur.amountSold);
        }, 0);

        this.pmsSummary = { volume, amount };
        // this.pmsSummary = psummary[0];
        this.hasPms = true;
        prodCount++;
      }

      let asummary = productSummary.filter(
        (prod) =>
          prod.product.toLowerCase() ==
          this.countryProducts.productsLower.product2
      );
      if (asummary.length) {
        let volume = asummary.reduce((prev, cur) => {
          return Number(prev) + Number(cur.volumeSold);
        }, 0);

        let amount = asummary.reduce((prev, cur) => {
          return Number(prev) + Number(cur.amountSold);
        }, 0);

        this.agoSummary = { volume, amount };
        // this.agoSummary = asummary[0];
        this.hasAgo = true;
        prodCount++;
      }

      let dsummary = productSummary.filter(
        (prod) =>
          prod.product.toLowerCase() ==
          this.countryProducts.productsLower.product3
      );

      if (dsummary.length) {
        let volume = dsummary.reduce((prev, cur) => {
          return Number(prev) + Number(cur.volumeSold);
        }, 0);

        let amount = dsummary.reduce((prev, cur) => {
          return Number(prev) + Number(cur.amountSold);
        }, 0);

        this.dpkSummary = { volume, amount };

        this.hasDpk = true;
        prodCount++;
      }

      let lsummary = productSummary.filter(
        (prod) =>
          prod.product.toLowerCase() ==
          this.countryProducts.productsLower.product4
      );
      if (lsummary.length) {
        let volume = lsummary.reduce((prev, cur) => {
          return Number(prev) + Number(cur.volumeSold);
        }, 0);

        let amount = lsummary.reduce((prev, cur) => {
          return Number(prev) + Number(cur.amountSold);
        }, 0);

        this.lpgSummary = { volume, amount };
        // this.lpgSummary = lsummary[0];
        this.hasLpg = true;
        prodCount++;
      }
      prodCount++;
      // let columnNumber;
      // prodCount !== 5
      //   ? (columnNumber = 12 / prodCount)
      //   : (columnNumber = 3);
      // this.productCount = `col-lg-${columnNumber}`;
    },
    rowDataBound: function (args) {
      if (args.data["dealerName"] === "Total Sales") {
        args.row.cells[1].innerHTML = `<button class='total_sales_button'>${args.data["dealerName"]}</button>`;
      }
    },
    activateTab(voucher_type) {
      this.activeTab = voucher_type;
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    changeRoute($newRoute) {
      this.$router.push({ name: $newRoute });
    },
    parseBranch(data) {
      const groups = data.reduce((groups, sales) => {
        const branchName = sales.branchName;
        if (!groups[branchName]) {
          groups[branchName] = [];
        }
        groups[branchName].push(sales);
        return groups;
      }, {});

      this.parseBranchChart(groups);

      if (!Object.keys(groups).length) {
        this.hasPms = true;
        this.hasAgo = true;
        this.hasDpk = true;
        this.hasLpg = true;
      } else {
        this.hasPms = false;
        this.hasAgo = false;
        this.hasDpk = false;
        this.hasLpg = false;
      }
      let count = 0;
      const groupArrays = Object.keys(groups).map((branchName) => {
        let agoAmount = 0;
        let agoVolume = 0;
        let pmsAmount = 0;
        let pmsVolume = 0;
        let dpkAmount = 0;
        let dpkVolume = 0;
        let lpgAmount = 0;
        let lpgVolume = 0;
        let totalSales = 0;
        let region;
        let state;
        groups[branchName].forEach((branch) => {
          region = branch.region;
          state = branch.state;
          if (branch.productName === this.countryProducts.products.product1) {
            this.hasPms = true;
            pmsAmount = pmsAmount + branch.amountSold;
            pmsVolume = pmsVolume + branch.volumeSold;
          }
          if (branch.productName === this.countryProducts.products.product2) {
            this.hasAgo = true;
            agoAmount += branch.amountSold;
            agoVolume += branch.volumeSold;
          }

          if (branch.productName === this.countryProducts.products.product3) {
            this.hasDpk = true;
            dpkAmount += branch.amountSold;
            dpkVolume += branch.volumeSold;
          }
          if (branch.productName === this.countryProducts.products.product4) {
            this.hasLpg = true;
            lpgAmount = lpgAmount + branch.amountSold;
            lpgVolume = lpgVolume + branch.volumeSold;
          }

          totalSales += branch.amountSold;
        });

        return {
          branchName: branchName && branchName.trim(),
          pmsVolume: pmsVolume,
          pmsAmount: pmsAmount,
          agoVolume: agoVolume,
          agoAmount: agoAmount,
          dpkVolume: dpkVolume,
          dpkAmount: dpkAmount,
          lpgVolume: lpgVolume,
          lpgAmount: lpgAmount,
          totalAmount: totalSales,
          region,
          state,
        };
      });
      groupArrays.sort((a, b) => {
        return a.branchName > b.branchName
          ? 1
          : a.branchName < b.branchName
          ? -1
          : 0;
      });

      groupArrays.forEach((el) => (el.index = ++count));

      this.companySalesTransactions = groupArrays;
      this.$refs.dataGrid.ej2Instances.setProperties({
        dataSource: groupArrays,
      });
      this.refreshGrid();
    },
    parseBranchChart(groupData) {
      let count = 0;
      let categories = [];
      let agoSeriesArr = [];
      let dpkSeriesArr = [];
      let pmsSeriesArr = [];
      let lpgSeriesArr = [];

      const categoriesArr = Object.keys(groupData).forEach((x) => {
        categories.push(x);
        let pms = 0;
        let ago = 0;
        let dpk = 0;
        let lpg = 0;
        groupData[x].forEach((gr) => {
          if (gr.productName === this.countryProducts.products.product2) {
            ago += gr.volumeSold;
          }
          if (gr.productName === this.countryProducts.products.product3) {
            dpk += gr.volumeSold;
          }
          if (gr.productName === this.countryProducts.products.product1) {
            pms += gr.volumeSold;
          }
          if (gr.productName === this.countryProducts.products.product4) {
            lpg += gr.volumeSold;
          }
        });
        agoSeriesArr.push(ago);
        dpkSeriesArr.push(dpk);
        pmsSeriesArr.push(pms);
        lpgSeriesArr.push(lpg);
      });

      this.chartOptions.series = [
        {
          name: this.countryProducts.products.product2,
          data: agoSeriesArr,
        },
        {
          name: this.countryProducts.products.product3,
          data: dpkSeriesArr,
        },
        {
          name: this.countryProducts.products.product1,
          data: pmsSeriesArr,
        },
        {
          name: this.countryProducts.products.product4,
          data: lpgSeriesArr,
        },
      ];
      this.chartOptions.xAxis.categories = categories;
    },
  },
};
</script>
<style>
@media print {
  .first_tab {
    background-color: #4b2d73;
  }
}
</style>
